import { render, staticRenderFns } from "./MonitoramentoDesmatamento.vue?vue&type=template&id=c1037534&lang=pug"
import script from "./MonitoramentoDesmatamento.vue?vue&type=script&lang=js"
export * from "./MonitoramentoDesmatamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports